import {
  SYS_BREAKPOINT_XS,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_2_XL,
} from '@oneaudi/unified-web-common';

const size = {
  mobileS: SYS_BREAKPOINT_XS,
  mobileM: SYS_BREAKPOINT_SM,
  mobileL: '425px',
  tablet: SYS_BREAKPOINT_MD,
  laptop: SYS_BREAKPOINT_LG,
  laptopM: '1300px',
  laptopL: SYS_BREAKPOINT_XL,
  laptopXL: '1600px',
  desktop: SYS_BREAKPOINT_2_XL,
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopM: `(min-width: ${size.laptopM})`,
  laptopL: `(min-width: ${size.laptopL})`,
  laptopXL: `(min-width: ${size.laptopXL})`,
  desktop: `(min-width: ${size.desktop})`,
};

export const deviceSizes = {
  mobileS: '320',
  mobileM: '375',
  mobileL: '425',
  tablet: '768',
  laptop: '1024',
  laptopL: '1440',
  laptopXL: '1600',
  desktop: '2560',
};
